import { render, staticRenderFns } from "./BmPedidoPagos.vue?vue&type=template&id=d40f6cf4&"
import script from "./BmPedidoPagos.vue?vue&type=script&lang=js&"
export * from "./BmPedidoPagos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports